export default "__VITE_ASSET__27fa198e__"